import { useMemo } from "react";
import { useWintSalaryService } from "serviceHooks";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { createConcurrentVacationWarning, toDateOnly } from "./concurrentVacationWarning";

/** A `customMessageHandler` for an `employmentEndDate` field; undefined when there is nothing to ask Wint Lön about. */
const useConcurrentVacationWarning = (personId: number | undefined, savedEndDate: unknown, enabled: boolean) => {
  const { getIsConcurrentVacationYear } = useWintSalaryService();
  const saved = toDateOnly(savedEndDate);

  return useMemo(() => {
    if (!enabled || !personId) return undefined;
    const warn = createConcurrentVacationWarning((endDate) => getIsConcurrentVacationYear(personId, endDate), saved, {
      withoutReason: () =>
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ConcurrentVacationEndDateWarning),
      withReason: () =>
        LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Settings.ConcurrentVacationEndDateWarningWithReason
        ),
    });
    return (values: {
      employmentEndDate?: unknown;
      terminationReason?: WintSuperkollAPIModel.EmploymentTerminationReason;
    }) => warn(values.employmentEndDate, values.terminationReason);
    // The service is recreated every render; keying on it would drop the per-date cache each time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, personId, saved]);
};

export default useConcurrentVacationWarning;
